import { Component, OnDestroy, OnInit } from '@angular/core';
import {ContentService} from '../../services/content.service'
import {Subject,takeUntil} from 'rxjs'
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatChipSet, MatChip, MatChipRemove } from '@angular/material/chips';

@Component({
    selector: 'app-add-other-preference-dialog',
    templateUrl: './add-other-preference-dialog.component.html',
    styleUrls: ['./add-other-preference-dialog.component.scss'],
    imports: [MatIconButton, MatIcon, MatChipSet, MatChip, MatChipRemove, MatButton]
})
export class AddOtherPreferenceDialogComponent implements OnInit, OnDestroy {
private destroy$ = new Subject<void>();
content:any;
constructor(private contentService:ContentService){

}
ngOnInit(){
  this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
    this.content = res;
  })
}
ngOnDestroy(){
  this.destroy$.next();
  this.destroy$.complete();
}
}
